/**
 * Amplifyからのエラーメッセージを和訳するためのdict.
 */
export const translations: { [key: string]: { [key: string]: string } } = {
    ja: {
        'User does not exist.': 'メールアドレスまたはパスワードが違います。',
        'Incorrect username or password.': 'メールアドレスまたはパスワードが違います。',
        'User has no access rights': 'メールアドレスまたはパスワードが違います。',
        'Password attempts exceeded': 'アカウントが一時的にブロックされています',

        'Invalid verification code provided, please try again.': '不正な認証コードです。もう1度お試しください。',
        'Organization is not active': '企業が無効に設定されましたので、ログインできません。',

        'Username/client id combination not found.': 'メールアドレスは登録されていません。',
    },
}

export default function translate(message: string) {
    const translation = translations['ja'][message]
    if (translation) {
        return translation
    } else {
        console.warn('エラーメッセージの日本語訳はまだありません。')
    }
}
